/**
 * useBeforeUnload — browser confirmation dialog on tab close when there are
 * unsaved changes (spec.md § Editor / Manual save: "Browser dialog
 * (beforeunload) on tab close with unsaved changes").
 *
 * The handler is only attached while `enabled` is true, so a clean/saved pad
 * closes without a prompt.
 */
import { useEffect } from "react";

export function useBeforeUnload(enabled: boolean): void {
  useEffect(() => {
    if (!enabled) return;
    const handler = (event: BeforeUnloadEvent) => {
      // Modern browsers ignore custom strings but require preventDefault +
      // a truthy returnValue to show the native dialog.
      event.preventDefault();
      event.returnValue = "";
    };
    window.addEventListener("beforeunload", handler);
    return () => window.removeEventListener("beforeunload", handler);
  }, [enabled]);
}
